import { render } from "./PoliciesLocal.vue?vue&type=template&id=159d3f29"
import script from "./PoliciesLocal.vue?vue&type=script&lang=js"
export * from "./PoliciesLocal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__